module.exports = __webpack_public_path__ + "media/images/front/icons/J&J_close_icon-c825d0cb36880638fdc24bc0b8cb43b0.png";